import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PortalOperationLogParam } from 'server/entity/portal-operation-log-param';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OperationLogService {

  constructor(
    private http: HttpClient,
    private httpBackend: HttpBackend,
  ) {
    this.http = new HttpClient(this.httpBackend);
  }

  async getOperationLogParam(): Promise<any> {
    // return this.http.get<PortalOperationLogParam[]>('/api/operationLogParam').toPromise();
    return this.http.get<PortalOperationLogParam[]>(`${environment.logisticsApiUrl}/Common/getPortalOperationLogParam`).toPromise();
  }

  saveOperationLog(saveObj: any): Observable<void> {
    // const url = '/api/operationLog';
    const url = `${environment.logisticsApiUrl}/Common/savePortalOperationLog`;
    return this.http.post<void>(url, saveObj);
  }
}
